<template>
  <div class="purchase">
    <div class="title">買取</div>
    <p>買取が発生する場合は、買取額を記入してください。</p>
    <p class='error'>{{ error }}</p>
    <label class='input-group'>
      <label>買取額</label>
      <input type="text" inputmode="numeric" pattern="[0-9]*"
             onkeypress='return /[\d]/.test(event.key)'
             @blur='inputPurchase'
             :value='purchaseDisplay'>
      <span>円</span>
    </label>
    <div class="show-area">
      <p>以下、買取額適用後の金額となります。</p>
      <div class="input-group">
        <label>施工金額
          <div class="subLabel">（税込）</div>
        </label>
        <input type="text"
               readonly="readonly"
               :value='moneyDisplay'>
        <span>円</span>
      </div>
      <div class="input-group">
        <label>内、消費税
          <div class="discount-text">{{ taxRateDisplay }}%</div></label>
        <input type="text" inputmode="numeric" pattern="[0-9]*" readonly='true'
               :value='taxDisplay'>
        <span>円</span>
      </div>
      <div class="input-group">
        <label style='color: red'>口コミ割</label>
        <input type="text" inputmode="numeric" pattern="[0-9]*" readonly='true'
               style='color: red'
               :value='discountReviewedDisplay'>
        <span>円</span>
      </div>
      <div class="input-group">
        <label v-bind:style="{color: minusTextColorTotal}">ご請求金額</label>
        <input type="text" readonly="true" :value='totalDisplay' v-bind:style="{color: minusTextColorTotal}">
        <span>円</span>
      </div>
    </div>
    <div class="floating-actions settled">
      <button type='button' class="btn"
              :disabled='!submitable'
              @click='submit'>
        確定
      </button>
      <button type='button' class='btn'
              @click='submitWithFree'>
        無料引取
      </button>
      <button type='button' class='btn btn-danger'
              @click='unusePurchase'>
        買取しない
      </button>
    </div>
  </div>
</template>

<script>

const Currency = new Intl.NumberFormat('ja-JP', {style: 'currency', currency: 'JPY'});
const toCurrency = function (value) {
  return Currency.format(value).replace(/[^\d,-]/g, '')
}
const stripNonDigit = function (value) {
  return Number.parseInt(value.toString().replace(/\D/g, ''))
}
export default {
  props: ['order'],
  data: function () {
    return {
      purchase: 0,
      use_purchase: 1,
      tax: 0,
      money: 0,
      taxRate: 0,
      total: 0,

      discount: 0,
      discountRate: 0,
      discountTemporary: 0,

      error: '',
      loading: false,
    }
  },
  computed: {
    purchaseDisplay: function () {
      return toCurrency(this.purchase)
    },
    moneyDisplay: function () {
      return toCurrency(this.money + this.tax)
    },
    taxDisplay: function () {
      return toCurrency(this.tax)
    },
    taxRateDisplay: function () {
      return (this.taxRate !== 0) ? (this.taxRate * 100) : 0
    },
    discountDisplay: function () {
      return (this.discount ? '- ' : '') + toCurrency(this.discount)
    },
    discountReviewedDisplay: function () {
      if (this.order.info_steps[4].already_reviewed && this.order.info_steps[4].discount_reviewed_price > 0) {
        return toCurrency(this.order.info_steps[4].discount_reviewed_price)
      } else {
        return 0
      }
    },
    discountTemporaryDisplay: function () {
      return toCurrency(this.discountTemporary)
    },
    totalDisplay: function () {
      return toCurrency(this.total)
    },
    submitable: function () {
      return this.purchase !== '' &&
          this.error === ''
    },
    minusTextColorTotal: function () {
      return this.total < 0 ? 'red' : 'black'
    }
  },
  name: "Receipt",
  methods: {
    inputPurchase: function ($event) {
      this.purchase = Number.parseInt(stripNonDigit($event.target.value)) || 0;
      this.calc();
    },
    calc: function () {
      this.tax = Math.floor(this.money * this.taxRate);
      this.discount = Math.floor((this.money + this.tax) * this.discountRate);
      this.total = this.money + this.tax - this.discount - (this.purchase || 0);
      if (this.order.info_steps[4].already_reviewed && this.order.info_steps[4].discount_reviewed_price > 0) {
        this.total -= this.order.info_steps[4].discount_reviewed_price
      }
      if (this.total < 0) {
        this.total = 0
      }
    },
    unusePurchase: function () {
      this.$$.alert({
        message: '買取を止めます。よろしいですか？',
        actionText: 'はい',
        cancelText: 'いいえ',
        action: () => {
          this.use_purchase = 0;
          this.purchase = 0;
          this.calc();
          this.submit();
        },
        cancelAction: () => null,
      })
    },
    submitWithFree: function () {
      this.purchase = 0;
      this.calc();
      this.submit();
    },
    submit: function () {
      if (!this.loading) {
        let order_id = this.$route.params.id
        this.loading = true;
        this.$api
            .postOrderPurchase(order_id, this.use_purchase, this.purchase)
            .then((res) => {
              this.order.info_steps = res.data.data.info_steps;
              this.$router.push({name: 'orderSteps'});
              this.$$.flash();
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            })
            .then(() => {
              this.loading = false;
            })
      }
    }
  },
  created: function () {
    if (!this.order) this.$router.push({name: 'orderSteps'})
    if (this.order) {
      let moneyDefault = Number.parseInt(this.order.info_steps[4].amount_default)
      let moneyPaid = Number.parseInt(this.order.info_steps[4].amount_paid)
      let willDiscount = Number.parseInt(this.order.order.survey_flag) || 0

      this.purchase = Number.parseInt(this.order.info_steps[3].amount)

      this.taxRate
          = Number.parseFloat(this.order.tax_rate);
      this.discountRate
          = (Number.parseFloat(this.order.discount_rate) || 0) * willDiscount;

      if (moneyPaid) {
        this.money = moneyPaid;
      } else {
        this.money = Math.floor((moneyDefault / Math.round((1 + this.taxRate) * 100)) * 100);
      }

      this.calc();
    }
  },
  mounted: function () {
    this.$$.context({
      previous: 'トップへ',
      title: "ID:" + this.$route.params.id,
      previousRouteName: 'orderSteps',
    });
  }
}
</script>

<style lang='scss'>
.purchase {
  padding: 1em 2em;
  max-width: 480px;
  margin: auto;

  .title {
    font-size: 1.125em;
    font-weight: bold;
    text-align: center;
  }

  .error {
    color: red;
    height: 2em;
    text-align: center;
  }

  .input-group {
    margin-bottom: 1.5em;

    label {
      width: 8em;
      flex-grow: 0;
      flex-shrink: 0;
      text-align: center;
    }

    input {
      font-size: 1.5em;
      padding: .15em;
      line-height: 1;
      height: auto;
      text-align: right;
    }

    span {
      font-size: 1.5em;
      padding: 0 .25em;
    }

    &:last-child {
      margin-top: 2.5em;
    }
  }

  .show-area {
    padding: 5px;
    background-color: #eeffee;
    border: 1px solid #339933;
    font-size: 0.75em;
  }


  .subLabel {
    font-size: .65em;
  }

  .btn {
    min-width: 10em;
  }
}
</style>